const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export async function fetchDashboardData(viewMode) {
  const isDemoMode = viewMode === 'demo';
  const queryParam = isDemoMode ? '?include_demo=true' : '';
  const headers = getAuthHeaders();

  const [summaryRes, investmentsRes, eligibilityRes, sharingEligRes] = await Promise.all([
    fetch(`${BACKEND_URL}/api/portfolio/summary${queryParam}`, { headers, cache: 'no-store' }),
    fetch(`${BACKEND_URL}/api/investments${queryParam}`, { headers, cache: 'no-store' }),
    fetch(`${BACKEND_URL}/api/users/introduction-eligibility-status`, { headers, cache: 'no-store' }),
    fetch(`${BACKEND_URL}/api/portfolio/sharing-eligibility`, { headers, cache: 'no-store' })
  ]);

  if (!summaryRes.ok || !investmentsRes.ok) {
    throw new Error('Failed to load dashboard data');
  }

  const summary = await summaryRes.json();
  const investments = await investmentsRes.json();
  const eligibility = eligibilityRes.ok ? await eligibilityRes.json() : null;
  const sharingEligible = sharingEligRes.ok ? (await sharingEligRes.json()).eligible : false;

  return { summary, investments, eligibility, sharingEligible };
}

export async function initializeDemoDataApi() {
  const headers = { 'Content-Type': 'application/json', ...getAuthHeaders() };
  const response = await fetch(`${BACKEND_URL}/api/demo/init`, { method: 'POST', headers });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to initialize demo data');
  }
  return response.json();
}

export async function clearDemoDataApi() {
  const response = await fetch(`${BACKEND_URL}/api/demo/clear`, { method: 'DELETE', headers: getAuthHeaders() });
  if (!response.ok) throw new Error('Failed to clear demo data');
  return response.json();
}

export async function deleteInvestmentApi(investmentId) {
  const response = await fetch(`${BACKEND_URL}/api/investments/${investmentId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!response.ok) throw new Error('Failed to delete investment');
  return response.json();
}

export async function fetchInvestmentByIdApi(investmentId) {
  const response = await fetch(`${BACKEND_URL}/api/investments/${investmentId}`, {
    headers: getAuthHeaders(),
    cache: 'no-store',
  });
  if (!response.ok) throw new Error('Failed to load investment');
  return response.json();
}

export async function checkPaymentStatus(sessionId) {
  const response = await fetch(`${BACKEND_URL}/api/payments/status/${sessionId}`);
  if (!response.ok) throw new Error('Failed to check payment status');
  return response.json();
}
